import { z, ZodType } from 'zod';

export type Connection = {
	connected: boolean;
};

export const connectionSchema: ZodType<Connection> = z.object({
	connected: z.boolean(),
});
